namespace Solovis.Reports.Parameters.ParameterTransforms {

    export interface TransformOptions {
        transform?: any;
        transformTree?: any;

        parameterValueGetter?: any;
        sourceParameterValueGetter?: any;
        priorParameterValueGetter?: any;        
        externalValues?: any;
        customFunctions?: any;
    }

    export function transform(value, options: TransformOptions) {
        if (!options.transform && !options.transformTree) {
            return value;
        }

        var parameterValueGetter = options.parameterValueGetter ? options.parameterValueGetter : null;
        var sourceParameterValueGetter = options.sourceParameterValueGetter ? options.sourceParameterValueGetter : null;
        var priorParameterValueGetter = options.priorParameterValueGetter ? options.priorParameterValueGetter : null;
        var externalValues = options.externalValues ? options.externalValues : null;
        var customFunctions = options.customFunctions ? options.customFunctions : null;

        var tree;
        if (options.transformTree) {
            tree = options.transformTree;
        }
        else {
            var transformStr = options.transform;
            tree = jsep(transformStr);
        }

        var transformer = new ParameterTransforms.Transformer(value, parameterValueGetter, sourceParameterValueGetter, priorParameterValueGetter, externalValues);
        transformer.customFunctions = customFunctions;

        var newValue = transformer.tranformNode(tree);

        return newValue;
    };


    export class Transformer {

        public customFunctions;

        public value;
        public _parameterValueGetter;
        public _sourceParameterValueGetter;
        public _priorParameterValueGetter;
        public _externalValues;

        /**
         * transforms can temporarily save data to custom state.
         */
        private _customState = {};

        constructor(value, parameterValueGetter, sourceParameterValueGetter, priorParameterValueGetter, externalValues) {
            this.value = value;
            this._parameterValueGetter = parameterValueGetter;
            this._sourceParameterValueGetter = sourceParameterValueGetter;
            this._priorParameterValueGetter = priorParameterValueGetter;
            this._externalValues = externalValues;
        }

        public tranformNode(node) {
            if (!node) {
                return null;
            }

            var result;

            if (node.type === "Identifier") {
                result = this._evalIdentifier(node);
                return result;
            }
            else if (node.type === "Literal") {
                result = node.value;
                return result;
            }
            else if (node.type === "CallExpression") {
                result = this._evalCallExpression(node);
                return result;
            }
            else if (node.type === "UnaryExpression") {
                result = this._evalUnaryExpression(node);
                return result;
            }
            else if (node.type === "BinaryExpression") {
                result = this._evalBinaryExpression(node);
                return result;
            }
            else if (node.type === "LogicalExpression") {
                result = this._evalLogicalExpression(node);
                return result;
            }
            else if (node.type === "MemberExpression") {
                result = this._evalMemberExpression(node);
                return result;
            }
            else if (node.type === "Compound") {
                result = this._evalCompound(node);
                return result;
            }

            throw "ParameterTransforms.Transformer: Unknown node type: " + node.type;
        };

        public _evalIdentifier(node) {
            if (node.name == "value") {
                return this.value;
            }
            else if (node.name == "values") {
                return this._externalValues;
            }
            else if (node.name == "today") {
                return InvData.Util.DateIndexHelper.getDateIndexForToday();
            }
            else if (node.name == "yesterday") {
                return (InvData.Util.DateIndexHelper.getDateIndexForToday() - 1);
            }
            else if (node.name == "hourOfDay") {
                var hour = (new Date()).getHours();
                return hour;
            }
            else if (node.name == "utcHourOfDay") {
                var hour = Solovis.Time.getUtcDateFromLocalDate(new Date()).getHours();
                return hour;
            }
            else if (node.name == "saved") {
                return this._customState;
            }

            throw "ParameterTransforms.Transformer: Unknown identifier: " + node.name;
        };

        public _evalCallExpression(node) {
            var self = this;
            var callArguments = _.map(node.arguments, function (i) { return self.tranformNode(i); });

            if (node.callee) {
                if (node.callee.type == "Identifier") {
                    var method = this._getFunctionForIdentifier(node.callee.name);
                    if (method) {
                        var callResult = method.apply(this, callArguments);
                        return callResult;
                    }
                }
            }

            throw "ParameterTransforms.Transformer: Unknown call expression";
        };

        public _evalUnaryExpression(node) {
            var self = this;
            var callArguments = [];
            callArguments.push(this.tranformNode(node.argument));

            if (node.operator) {
                var method = null;
                if (node.operator == "!") {
                    method = ParameterTransforms._allowedFunctions.not;
                }
                else if (node.operator == "-") {
                    method = ParameterTransforms._allowedFunctions.negative;
                }

                if (method) {
                    var callResult = method.apply(this, callArguments);
                    return callResult;
                }
            }

            throw "ParameterTransforms.Transformer: Unsupported unary operator: " + node.operator;
        };

        public _evalBinaryExpression(node) {
            var self = this;
            var callArguments = [];

            if (node.operator === ":" && node.left.type === "Identifier") {
                // Special handling of identifier for field declarations.
                callArguments.push(node.left.name);
            }
            else {
                callArguments.push(this.tranformNode(node.left));
            }

            callArguments.push(this.tranformNode(node.right));

            if (node.operator) {
                var method = null;
                if (node.operator === "+") {
                    method = ParameterTransforms._allowedFunctions.add;
                }
                else if (node.operator === "-") {
                    method = ParameterTransforms._allowedFunctions.subtract;
                }
                else if (node.operator === "*") {
                    method = ParameterTransforms._allowedFunctions.multiply;
                }
                else if (node.operator === "/") {
                    method = ParameterTransforms._allowedFunctions.divide;
                }
                else if (node.operator === "<") {
                    method = ParameterTransforms._allowedFunctions.lessThan;
                }
                else if (node.operator === "<=") {
                    method = ParameterTransforms._allowedFunctions.lessThanOrEqual;
                }
                else if (node.operator === "==") {
                    method = ParameterTransforms._allowedFunctions.equal;
                }
                else if (node.operator === "!=") {
                    method = ParameterTransforms._allowedFunctions.notEqual;
                }
                else if (node.operator === ">") {
                    method = ParameterTransforms._allowedFunctions.greaterThan;
                }
                else if (node.operator === ">=") {
                    method = ParameterTransforms._allowedFunctions.greaterThanOrEqual;
                }
                else if (node.operator === ":") {
                    method = ParameterTransforms._allowedFunctions.field;
                }

                if (method) {
                    var callResult = method.apply(this, callArguments);
                    return callResult;
                }
            }

            throw "ParameterTransforms.Transformer: Unsupported operator: " + node.operator;
        };

        public _evalLogicalExpression(node) {
            var self = this;
            var callArguments = [];
            callArguments.push(this.tranformNode(node.left));
            callArguments.push(this.tranformNode(node.right));

            if (node.operator) {
                var method = null;
                if (node.operator == "&&") {
                    method = ParameterTransforms._allowedFunctions.and;
                }
                else if (node.operator == "||") {
                    method = ParameterTransforms._allowedFunctions.or;
                }

                if (method) {
                    var callResult = method.apply(this, callArguments);
                    return callResult;
                }
            }

            throw "ParameterTransforms.Transformer: Unsupported logical expression: " + node.operator;
        };


        public _evalMemberExpression(node) {
            let object = this.tranformNode(node.object);

            let propertyName;
            if (node.property.type === "Identifier") {
                propertyName = node.property.name;
            }
            else {
                throw "ParameterTransforms.Transformer: Expected identifier for member expression property.";
            }

            if (object) {
                if (Solovis.isNotNull(object[propertyName])) {
                    return object[propertyName];
                }
            }           
             
            return null;            
        }

        public _evalCompound(node) {
            let lastResult = null;

            if (node.body) {
                for (let childNode of node.body) {
                    lastResult = this.tranformNode(childNode);
                }
            }

            return lastResult;
        }

        public _getFunctionForIdentifier = function (name) {
            if (this.customFunctions) {
                var customMethod = this.customFunctions[name];
                if (customMethod)
                    return customMethod;
            }

            var method = ParameterTransforms._allowedFunctions[name];
            if (method)
                return method;

            throw "ParameterTransforms.Transformer: Unknown method name: " + name;
        };
    }

    

    // NOTE: We intentionally provide a limited set of functions to prevent arbitrary javascript execution.
    export var _allowedFunctions: any = {};

    _allowedFunctions.add = function (value1, value2) {
        var result = value1 + value2;
        return result;
    };

    _allowedFunctions.subtract = function (value1, value2) {
        var result = value1 - value2;
        return result;
    };

    _allowedFunctions.multiply = function (value1, value2) {
        var result = value1 * value2;
        return result;
    };

    _allowedFunctions.divide = function (value1, value2) {
        var result = value1 / value2;
        return result;
    };

    _allowedFunctions.negative = function (value1) {
        if (Solovis.isNotNull(value1)) {
            return -value1;
        }

        return null;
    };

    _allowedFunctions.if = function (test, ifTrue, ifFalse) {
        if (test) {
            return ifTrue;
        }
        else {
            return ifFalse;
        }
    };

    _allowedFunctions.lessThan = function (value1, value2) {
        var result = value1 < value2;
        return result;
    };

    _allowedFunctions.lessThanOrEqual = function (value1, value2) {
        var result = value1 <= value2;
        return result;
    };

    _allowedFunctions.equal = function (value1, value2) {
        var result = value1 == value2;
        return result;
    };

    _allowedFunctions.notEqual = function (value1, value2) {
        var result = value1 != value2;
        return result;
    };


    _allowedFunctions.greaterThan = function (value1, value2) {
        var result = value1 > value2;
        return result;
    };

    _allowedFunctions.greaterThanOrEqual = function (value1, value2) {
        var result = value1 >= value2;
        return result;
    };

    _allowedFunctions.and = function (value1, value2) {
        var result = (value1 && value2) ? true : false;
        return result;
    };

    _allowedFunctions.or = function (value1, value2) {
        var result = (value1 || value2) ? true : false;
        return result;
    };

    _allowedFunctions.not = function (value1) {
        var result = !value1;
        return result;
    };

    _allowedFunctions.isNull = function (value1) {
        if (Solovis.isNull(value1)) {
            return true;
        }
        return false;
    };

    _allowedFunctions.max = function () {
        if (arguments.length == 0) {
            return null;
        }

        var max = arguments[0];
        for (var i = 1; i < arguments.length; i++) {
            if (max < arguments[i]) {
                max = arguments[i];
            }
        }
        return max;
    };

    _allowedFunctions.min = function () {
        if (arguments.length == 0) {
            return null;
        }
        var min = arguments[0];
        for (var i = 1; i < arguments.length; i++) {
            if (min > arguments[i]) {
                min = arguments[i];
            }
        }
        return min;
    };

    _allowedFunctions.maxPos = function () {
        if (arguments.length == 0) {
            return -1;
        }

        var max = arguments[0];
        var maxPos = 0;
        for (var i = 1; i < arguments.length; i++) {
            if (max < arguments[i]) {
                max = arguments[i];
                maxPos = i;
            }
        }
        return maxPos;
    };

    _allowedFunctions.minPos = function () {
        if (arguments.length == 0) {
            return -1;
        }
        var min = arguments[0];
        var minPos = 0;
        for (var i = 1; i < arguments.length; i++) {
            if (min > arguments[i]) {
                min = arguments[i];
                minPos = i;
            }
        }
        return minPos;
    };



    _allowedFunctions.lastDayOfMonth = function (value, offset) {
        // Retrieve date index of last day of month.
        if (Solovis.isNull(offset)) {
            offset = 0;
        }
        
        let date: Date;
        if (typeof value === "number") {
            date = InvData.DayId.toDate(value);
        }
        else {
            date = value as Date;
        }

        let dayId = InvData.DayId.forDate(date, InvData.RelativeDate.MonthEnd, offset);
        
        return dayId;
    };

    _allowedFunctions.lastDayOfPreviousMonth = function (value) {
        // Retrieve date index of last day of previous month.
        var lastDayInMonth = InvData.Util.DateIndexHelper.getDateIndexOfLastDayInPreviousMonth(value);
        return lastDayInMonth;
    };

    _allowedFunctions.lastDayOfQuarter = function (value, offset) {
        // Retrieve date index of last day of previous quarter.        
        if (Solovis.isNull(offset)) {
            offset = 0;
        }

        let date: Date;
        if (typeof value === "number") {
            date = InvData.DayId.toDate(value);
        }
        else {
            date = value as Date;
        }

        let dayId = InvData.DayId.forDate(date, InvData.RelativeDate.QuarterEnd, offset);

        return dayId;
    };

    _allowedFunctions.lastDayOfPreviousQuarter = function (value) {
        // Retrieve date index of last day of previous quarter.
        var lastDayInQuarter = InvData.Util.DateIndexHelper.getDateIndexOfLastDayInPreviousQuarter(value);
        return lastDayInQuarter;
    };

    _allowedFunctions.lastDayOfYear = function (value, offset) {
        // Retrieve date index of last day of year.
        if (Solovis.isNull(offset)) {
            offset = 0;
        }

        let date: Date;
        if (typeof value === "number") {
            date = InvData.DayId.toDate(value);
        }
        else {
            date = value as Date;
        }

        let dayId = InvData.DayId.forDate(date, InvData.RelativeDate.YearEnd, offset);

        return dayId;
    };

    _allowedFunctions.lastDayOfPreviousYear = function (value) {
        // Retrieve date index of last day of previous year.
        var lastDayInYear = InvData.Util.DateIndexHelper.getDateIndexOfLastDayInPreviousYear(value);
        return lastDayInYear;
    };

    _allowedFunctions.countMonths = function (fromDayId, toDayId, excludePartialMonths?) {
        let monthCount = InvData.Util.DateIndexHelper.countMonths(fromDayId, toDayId, excludePartialMonths);
        return monthCount;
    };

    _allowedFunctions.prop = function (value, propertyName) {
        // Return property from object with given name.
        if (value && typeof value === "object") {
            var propValue = value[propertyName];
            if (Solovis.isNotNull(propValue)) {
                return propValue;
            }
        }

        return null;
    };

    _allowedFunctions.param = function (parameterName) {
        // Retrieve another parameter value based on its name.
        if (parameterName && this._parameterValueGetter) {
            var paramValue = this._parameterValueGetter(parameterName);
            return paramValue;
        }

        return null;
    };

    _allowedFunctions.sourceParam = function (parameterName) {
        // Retrieve another parameter value from parent-level entity based on its name.
        if (parameterName && this._sourceParameterValueGetter) {
            var paramValue = this._sourceParameterValueGetter(parameterName);
            return paramValue;
        }

        return null;
    };

    _allowedFunctions.priorParam = function (parameterName) {
        // Retrieve previous parameter value from parent-level entity based on its name.        
        if (parameterName && this._priorParameterValueGetter) {
            var paramValue = this._priorParameterValueGetter(parameterName);
            return paramValue;
        }

        return null;
    };


    _allowedFunctions.array = function () {
        // Create an array from all of the arguments (returns null if there are no arguments).
        if (arguments && arguments.length > 0) {
            var newArray = [];
            $(arguments).each(function (i, item) {
                newArray.push(item);
            });
            return newArray;
        }

        return null;
    };

    _allowedFunctions.arrayMerge = function () {
        // Create an array where any items that are arrays will have their items pulled into the top-level.
        if (arguments && arguments.length > 0) {
            var newArray = [];

            $(arguments).each(function (i, item) {
                if (item && item.constructor === Array) {
                    // Merge in each child item.
                    $(item).each(function (i, childItem) {
                        newArray.push(childItem);
                    });
                }
                else {
                    newArray.push(item);
                }
            });

            return newArray;
        }

        return null;
    };

    _allowedFunctions.item = function (array, index) {
        if (!array) {
            return null;
        }

        // Retrieve item from an array.
        var item = array[index];
        if (Solovis.isNotNull(item)) {
            return item;
        }

        return null;
    };

    _allowedFunctions.slice = function (array, begin, end) {
        // Return a subsection of an array using traditional javascript array semantics.
        if (array) {
            return array.slice(begin, end);
        }

        return null;
    };

    _allowedFunctions.isEmpty = function (array) {
        // Returns true if array is null or has no items.
        if (!array || array.length == 0) {
            return true;
        }

        return false;
    };

    _allowedFunctions.removeEmptyItems = function (array) {
        // Create new copy of array by removing any null values from the array passed in.
        if (array && array.length > 0) {
            var newArray = [];
            $(array).each(function (i, item) {
                if (!ParameterTransforms._allowedFunctions.isEmpty(item)) {
                    newArray.push(item);
                }
            });

            if (newArray.length > 0) {
                return newArray;
            }
        }

        return null;
    };


    _allowedFunctions.field = function (name, value) {
        // Returns new object with a field of the given name and value.
        var newObject = {};
        newObject[name] = value;

        return newObject;
    };

    _allowedFunctions.objectMerge = function () {
        // Creates new object that includes a merge of all the values passed in.
        var newObject = {};

        if (arguments && arguments.length > 0) {
            $(arguments).each(function (i, arg) {
                $.extend(true, newObject, arg);
            });
        }

        return newObject;
    };

    // Alias "o" to objectMerge.
    _allowedFunctions.o = _allowedFunctions.objectMerge;

    ///
    /// Date methods.
    /// 
    function getDateForPossibleDateValue(possibleDateValue): Date {
        let date: Date;
        if (possibleDateValue instanceof Date) {
            date = possibleDateValue;
        }
        else if (typeof possibleDateValue === "number") {
            date = InvData.DayId.toDate(possibleDateValue);
        }

        return date;
    }

    _allowedFunctions.dateYear = function (possibleDateValue) {
        let date = getDateForPossibleDateValue(possibleDateValue);
        if (date) {
            return date.getFullYear();
        }

        return null;
    };

    _allowedFunctions.dateMonthNumber = function (possibleDateValue) {
        let date = getDateForPossibleDateValue(possibleDateValue);
        if (date) {
            return date.getMonth() + 1;
        }

        return null;
    };

    _allowedFunctions.dateDayOfMonth = function (possibleDateValue) {
        let date = getDateForPossibleDateValue(possibleDateValue);
        if (date) {
            return date.getDate();
        }

        return null;
    };

    _allowedFunctions.dateDayOfWeek = function (possibleDateValue) {
        let date = getDateForPossibleDateValue(possibleDateValue);
        if (date) {
            let day = date.getDay();
            if (day === 0) {
                // Using 7 for Sunday instead of 0.
                return 7;
            }
            else {
                return day;
            }
        }

        return null;
    };

    _allowedFunctions.formatDate = function (possibleDateValue, formatStr) {
        let date = getDateForPossibleDateValue(possibleDateValue);                
        if (date) {
            return kendo.toString(date, formatStr);
        }

        return null;
    };


    //
    // Numeric methods
    //
    _allowedFunctions.round = function (x) {
        return Math.round(x);
    }

    _allowedFunctions.floor = function (x) {
        return Math.floor(x);
    }

    _allowedFunctions.pow = function (x, y) {
        return Math.pow(x, y);
    }

    _allowedFunctions.ln = function (x) {
        return Math.log(x);
    }

    _allowedFunctions.abs = function (x) {
        return Math.abs(x);
    }

    _allowedFunctions.sqrt = function (x) {
        return Math.sqrt(x);
    }

    _allowedFunctions.inRange = function (x, lower, upper) {
        if (Solovis.isNotNull(x)) {
            if (Solovis.isNotNull(lower) && x < lower) {
                return false;
            }
            if (Solovis.isNotNull(upper) && x > upper) {
                return false;
            }
            return true;
        }
        return false;
    }


    //
    // HTML methods
    //
    _allowedFunctions.hyperlink = function (labelText, link) {
        let viz: any = {
            viz: true,
            hyperlink: {}
        };

        viz.hyperlink.label = labelText;

        // NOTE: Limits on allowed link values will be applied when viz object is turned into DOM element.
        viz.hyperlink.link = link;

        return viz;
    };


    //
    // Visualization methods
    // 
    _allowedFunctions.sparkline = function () {
        let values = [];
        let options = null;

        for (let i = 0; i < arguments.length; i++) {           
            let arg = arguments[i];
            if (arg && i === arguments.length - 1 && typeof arg === "object") {
                options = arg;
            }
            else {
                values.push(arg);
            }
        }

        let viz: any = {
            viz: true,
            sparkline: {}
        };

        viz.sparkline.values = values;

        if (options) {
            if (options.type) {
                viz.sparkline.type = options.type;
            }
            if (options.width) {
                viz.sparkline.width = options.width;
            }
            if (options.height) {
                viz.sparkline.height = options.height;
            }
        }

        return viz;
    }

    _allowedFunctions.bullet = function () {
        let viz: any = {
            viz: true,
            bullet: {}
        };

        let options: any;            

        for (let i = 0; i < arguments.length; i++) {
            let arg = arguments[i];
            if (arg && i === arguments.length - 1 && typeof arg === "object") {
                options = arg;
            }
            else {
                if (i == 0) {
                    viz.bullet.value = arg;
                }
                else if (i == 1) {
                    viz.bullet.target = arg;
                }
            }
        }

        if (options) {
            if (options.color) {
                viz.bullet.color = options.color;
            }
            if (options.width) {
                viz.bullet.width = options.width;
            }
            if (options.height) {
                viz.bullet.height = options.height;
            }
            if (options.targetColor) {
                viz.bullet.targetColor = options.targetColor;
            }
            if (options.startScaleValue) {
                viz.bullet.targetColor = options.startScaleValue;
            }
        }

        return viz;
    }


    ///
    /// Diagnostics
    ///

    _allowedFunctions.json = function (value) {
        return JSON.stringify(value, null, "    ");
    };

    _allowedFunctions.log = function (value) {
        console.log(value);
        return value;
    };


    //
    // External values
    //

    _allowedFunctions.external = function (name) {
        // Returns value from external parameters.
        if (this._externalValues) {
            var value = this._externalValues[name];
            if (Solovis.isNotNull(value)) {
                return value;
            }
        }

        return null;
    };


    //
    // Custom State
    //

    _allowedFunctions.save = function (name, value) {
        // Returns value from external parameters.
        if (this._customState) {
            this._customState[name] = value;            
        }

        return value;
    };



    export function findParameterDependencies(transformStr) {
        var tree = jsep(transformStr);

        var dependencies = [];

        var collectDependencies = function (node) {
            if (node.type == "CallExpression") {
                $(node.arguments).each(function (i, arg) {
                    collectDependencies(arg);
                });

                if (node.callee && node.callee.type == "Identifier") {
                    if (node.callee.name == "param") {
                        if (node.arguments && node.arguments.length > 0) {
                            var paramRefNode = node.arguments[0];
                            if (paramRefNode.type == "Literal") {
                                if (typeof paramRefNode.value == "string") {
                                    dependencies.push(paramRefNode.value);
                                }
                            }
                        }
                    }
                }
            }
            else if (node.type == "BinaryExpression" || node.type == "LogicalExpression") {
                collectDependencies(node.left);
                collectDependencies(node.right);
            }
            else if (node.type == "UnaryExpression") {
                collectDependencies(node.argument);
            }
        };

        collectDependencies(tree);

        return dependencies;
    };

}

/// !!!WARNING!!! This is a global modification to jsep to support ":" as a binary operator that maps a:b to field("a", b).
jsep.addBinaryOp(":");
    
